/** @module csi/widget/MaterialIconWithLabel */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"csi/html",
	"dojo/text!./MaterialIconWithLabel.html"
], function(declare,_WidgetBase,_TemplatedMixin,html,template) {

	const DEFAULT_ICON_SIZE = 16;

	const _MaterialIconWithLabel = declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csi-icon-with-label",
		templateString: template,
		
		/** @property {string} icon - name of material icon */
		icon: "",
		
		/** @property {string} iconCss - extra CSS to apply to icon */
		iconCss: "",

		/** @property {number} iconSize - size of icon in pixels */
		iconSize: DEFAULT_ICON_SIZE,

		/** @property {string} label - label to display after icon */
		label: "",
		
		/** @property {DomNode} labelNode - attach point, used in some widgets. Defined in template, please do not remove. Usage example - ToolbarWarning widget */
		// labelNode: null,
		
		/** @property {boolean} inline - render as an inline element, otherwise, flexbox way */
		inline: false,
		
		/** @property {boolean} wrap - render as an element wrap as needed, otherwise, no wrap way */
		wrap: false,
		
		/**
		 * Extension point for when widget is clicked
		 */
		onClick: function() { },
		
		/**
		 * Apply extra styling based on properties
		 */
		postCreate: function() {
			const {
				domNode,
				iconSize,
				inline,
				label,
				labelNode,
				wrap
			} = this;

			if (!label) {
				html.setVisible(domNode.lastChild, false);
			}

			if (inline) {
				domNode.classList.add("csi-flex-clear");
			}
			
			labelNode.classList.add( wrap ? "csi-ellipsis-wrap" : "csi-ellipsis-nowrap");

			if (iconSize != DEFAULT_ICON_SIZE) {
				html.setCSSVariable(domNode, "IconSize16", iconSize + html.PX);
			}
		},
		
		/**
		 * Click event handler
		 * @param {Event} e 
		 */
		_onClick: function(e) {
			this.onClick();
		}
	});

	/**
	 * Return HTML for widget rather than widget itself
	 * @param {Object} params
	 * @return {string}
	 */
	_MaterialIconWithLabel.getIconHtml = function(params) {
		const w = new _MaterialIconWithLabel(params);
		const value = w.domNode.outerHTML;

		// needed to remove widget from registry
		w.destroy();

		return value;
	};

	return _MaterialIconWithLabel;
});